export const TID = {
  landingHero: "landing-hero",
  loginGoogleBtn: "login-google-button",
  loginGoogleBtnHero: "login-google-hero-button",
  headerLogout: "header-logout-button",
  botToggle: "bot-status-toggle",
  botScan: "bot-scan-button",
  addSymbolInput: "add-symbol-input",
  addSymbolBtn: "add-symbol-button",
  watchlistItem: (s) => `watchlist-item-${s.toLowerCase()}`,
  removeSymbolBtn: (s) => `remove-symbol-${s.toLowerCase()}`,
  chartSymbolSelect: "chart-symbol-select",
  aiSignalRefresh: "ai-signal-refresh",
  aiAutoExecute: "ai-auto-execute",
  tradeSideBuy: "trade-side-buy",
  tradeSideSell: "trade-side-sell",
  tradeSymbolInput: "trade-symbol-input",
  tradeQtyInput: "trade-qty-input",
  tradeSubmit: "trade-submit-button",
  portfolioNetWorth: "portfolio-net-worth",
  portfolioCash: "portfolio-cash",
  portfolioPL: "portfolio-pl",
  settingsRisk: "settings-risk-tolerance",
  settingsPositionSize: "settings-position-size",
  settingsStopLoss: "settings-stop-loss",
  settingsTakeProfit: "settings-take-profit",
  settingsConfidence: "settings-confidence-threshold",
  settingsSave: "settings-save-button",
  tradeHistoryRow: (id) => `trade-history-${id}`,
  alpacaConnectBtn: "alpaca-connect-button",
  alpacaDisconnectBtn: "alpaca-disconnect-button",
  alpacaKeyInput: "alpaca-key-input",
  alpacaSecretInput: "alpaca-secret-input",
  alpacaModeSelect: "alpaca-mode-select",
  alpacaMirrorToggle: "alpaca-mirror-toggle",
  feeStatusCard: "fee-status-card",
  feePayBtn: "fee-pay-button",
  feeAutopayToggle: "fee-autopay-toggle",
  feeStatementBtn: "fee-statement-button",
  feeReminderBanner: "fee-reminder-banner",
  paymentSuccessTitle: "payment-success-title",
  paymentCancelTitle: "payment-cancel-title",
};
